import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import LiveRatesTable from '../components/LiveRatesTable';

export default function RatesPage() {
  return (
    <div className="min-h-screen pt-32 pb-20 px-6 md:px-12 lg:px-24">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <h1 className="font-heading text-4xl md:text-5xl font-bold mb-4">
            <span className="text-text-primary">Live </span>
            <span className="gold-gradient-text">Crypto Rates</span>
          </h1>
          <p className="text-text-secondary text-lg max-w-xl mx-auto">
            Real-time cryptocurrency prices with competitive buy and sell rates
          </p>
        </motion.div>

        {/* Rates Table */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="glass-card-gold p-8"
        >
          <LiveRatesTable compact={false} />
        </motion.div>

        {/* Info Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-12">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.3 }}
            className="glass-card p-6"
          >
            <h3 className="font-heading text-xl font-semibold text-text-primary mb-3">
              Buy Rate
            </h3>
            <p className="text-text-secondary">
              The price you pay when purchasing cryptocurrency from us. This includes our service fee for a seamless transaction.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.4 }}
            className="glass-card p-6"
          >
            <h3 className="font-heading text-xl font-semibold text-text-primary mb-3">
              Sell Rate
            </h3>
            <p className="text-text-secondary">
              The price you receive when selling cryptocurrency to us. Get instant payment to your preferred account.
            </p>
          </motion.div>
        </div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="text-center mt-12"
        >
          <Link to="/trade" data-testid="rates-trade-btn">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="btn-gold inline-flex items-center gap-2"
            >
              Start Trading
              <ArrowRight size={18} />
            </motion.button>
          </Link>
        </motion.div>
      </div>
    </div>
  );
}
